export default {
      id: "share-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "img/icons.ece5aa3c.svg#share",
      toString: function () {
        return this.url;
      }
    }